export const isAsciiString = (value: string) => {
  return value
    .split("")
    .map(c => c.charCodeAt(0))
    .every(c => c <= 127);
};
